import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/shared/web-core/src/components/core/loaders/FullPageLoading.tsx");
